import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'Originality',
    text: ' We allow our members to think and act in an original, autonomous, and unconventional fashion. This is enabled by our provision of inventive aptitude and high-level freshness of thoughts, and imagery.',
  },
  {
    title: 'Fluency',
    text: ' We instill verbal intelligence that is elaborative and simple. We influence our readers to attain seamless thought-flow that is demonstrated by the architecture of their articulation.',
  },
  {
    title: 'Truth',
    text: 'The inscriptions "Gaudium de Veritate" on our logo means, The Joy of Searching for, Discovering, and Communicating truth in Every Field. That is our credo, and we achieve it with the embrace of intellectual humility and intellectual courage.',
  },
  {
    title: 'Freedom',
    text: 'We advocate for freedom and independence of thoughts, speech, expression and judgement. We believe that freedom is an intrinsic human craving, and very meaningful for divergent thinking, and intelligence.',
  },
  {
    title: 'Flexibility',
    text: 'Our preference for breadth and depth is demonstrated by incorporating ideas that span beyond a narrow domain of knowledge. We pride in polymathy.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">The Epitome of Belles-Lettres</h1>
      <p>Values fostering our success</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;